// Measure complete prefixes so wrapping and proportional fonts are respected.
export function paginateText(text, fits) {
    const pages = [];
    let remaining = Array.from(text);
    while (remaining.length) {
        let low = 1;
        let high = remaining.length;
        let length = 1;
        while (low <= high) {
            const middle = Math.floor((low + high) / 2);
            if (fits(remaining.slice(0, middle).join(''))) {
                length = middle;
                low = middle + 1;
            } else {
                high = middle - 1;
            }
        }
        if (length < remaining.length) {
            const prefix = remaining.slice(0, length).join('');
            const sentences = [...prefix.matchAll(/[.!?;](?=\s)/gu)];
            const sentence = sentences[sentences.length - 1];
            let boundary = sentence ? sentence.index + 1 : remaining.slice(0, length + 1).join('').search(/\s+\S*$/u);
            // Keep short connecting words and negations with the following word.
            // For example, a new page must not turn "Не залишайте" into "залишайте".
            while (boundary > 0) {
                const trailingWord = prefix.slice(0, boundary).match(/(?:^|\s)\p{L}{1,3}$/u);
                if (!trailingWord || trailingWord.index === 0) break;
                boundary = trailingWord.index;
            }
            if (boundary > 0) length = Array.from(prefix.slice(0, boundary)).length;
        }
        pages.push(remaining.slice(0, length).join(''));
        remaining = remaining.slice(length);
    }
    return pages.length ? pages : [''];
}
